"use client";

import { parseDate, parseToDate } from "@/lib/utils";
import useServerTimeStore from "@/stores/useServerTimeStore";
import { useEffect } from "react";

const REFRESH_TIMER_MS = 60000 * 10; // 10 minutes

const ServerTimer = () => {
  const { setServerTime, initialServerTime } = useServerTimeStore();

  const fetchServerTime = async () => {
    try {
      const startTime = performance.now();

      const data = await fetch(`${window.location.origin}/api/server-time`, {
        headers: { "X-Requested-With": "fetch" },
      });

      const response = await data.json();
      const serverTime = response?.serverTime || null;

      const endTime = performance.now();
      const requestDurationMs = endTime - startTime;

      if (serverTime) {
        const serverTimeMs = parseDate(serverTime);

        const durationSeconds = Math.ceil(requestDurationMs);

        const serverDate = parseToDate(serverTimeMs + durationSeconds);
        const correctedTime = serverDate.toISOString().replace("Z", "+00:00");

        setServerTime(correctedTime);
      } else {
        setServerTime(null);
        //console.error("Failed to fetch server time:", response?.error);
      }
    } catch (error) {
      setServerTime(null);
      //console.error("Failed to fetch server time:", error);
    }
  };

  useEffect(() => {
    fetchServerTime();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchServerTime();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("load", fetchServerTime);
    window.addEventListener("online", fetchServerTime);
    window.addEventListener("offline", fetchServerTime);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("load", fetchServerTime);
      window.removeEventListener("online", fetchServerTime);
      window.removeEventListener("offline", fetchServerTime);
    };
  }, []);

  return null;
};

export default ServerTimer;
